import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'

interface Props {
  start: string
  end: string
}

function SearchTileRowOverlineJourney({ start, end }: Props) {
  const roundTrip = start === end

  return <BodyText variant="small" colour="neutral-two">
    {!roundTrip && <>Starts in <b>{start}</b>, ends in <b>{end}</b></>}
    {roundTrip && <>Starts and ends in <b>{start}</b></>}
  </BodyText>
}

export default SearchTileRowOverlineJourney
